import { render, staticRenderFns } from "./MemberSecond.vue?vue&type=template&id=710fd260&scoped=true"
import script from "./MemberSecond.vue?vue&type=script&lang=js"
export * from "./MemberSecond.vue?vue&type=script&lang=js"
import style0 from "./MemberSecond.vue?vue&type=style&index=0&id=710fd260&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710fd260",
  null
  
)

export default component.exports